import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';
import { Plus, Trophy } from 'lucide-react';

const METRICS = ['exercises_completed','lessons_completed','points','streak_days','games_analyzed'];

export default function AdminAchievements() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name:'', description:'', rarity:'common', points:50, metric:'exercises_completed', value:10 });
  const load = () => api.get('/achievements').then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      await api.post('/achievements', {
        name: f.name, description: f.description, rarity: f.rarity, points: Number(f.points),
        rule: { metric: f.metric, op: '>=', value: Number(f.value) }
      });
      toast.success('Logro creado'); setOpen(false); load();
    } catch { toast.error('Error'); }
  };
  return (
    <div className="p-8 max-w-6xl mx-auto">
      <PageHeader title="Logros" subtitle="Configura las metas de gamificación"
        right={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="new-ach-btn" className="rounded-full bg-blue-600 hover:bg-blue-700"><Plus className="w-4 h-4 mr-1"/>Nuevo logro</Button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Crear logro</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <Input placeholder="Nombre" value={f.name} onChange={(e)=>setF({...f,name:e.target.value})}/>
                <Textarea placeholder="Descripción" value={f.description} onChange={(e)=>setF({...f,description:e.target.value})}/>
                <div className="grid grid-cols-2 gap-2">
                  <Select value={f.rarity} onValueChange={(v)=>setF({...f,rarity:v})}>
                    <SelectTrigger><SelectValue/></SelectTrigger>
                    <SelectContent>{['common','rare','epic','legendary'].map(r=><SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
                  </Select>
                  <Input type="number" placeholder="Puntos" value={f.points} onChange={(e)=>setF({...f,points:e.target.value})}/>
                  <Select value={f.metric} onValueChange={(v)=>setF({...f,metric:v})}>
                    <SelectTrigger><SelectValue/></SelectTrigger>
                    <SelectContent>{METRICS.map(m=><SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent>
                  </Select>
                  <Input type="number" placeholder="Valor mínimo" value={f.value} onChange={(e)=>setF({...f,value:e.target.value})}/>
                </div>
              </div>
              <DialogFooter><Button onClick={save}>Crear</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        }
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(a => (
          <div key={a.id} className="rounded-2xl bg-white border border-slate-200 p-5">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-11 h-11 rounded-2xl bg-amber-500 text-white grid place-items-center"><Trophy className="w-5 h-5"/></div>
              <div>
                <div className="font-display font-bold">{a.name}</div>
                <div className="text-xs uppercase tracking-widest font-bold text-slate-500">{a.rarity} · +{a.points} pts</div>
              </div>
            </div>
            <div className="text-sm text-slate-600 mb-2">{a.description}</div>
            <div className="font-mono text-xs text-slate-500">
              Regla: {a.rule?.metric} {a.rule?.op} {a.rule?.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
